import { useNavigate, useParams } from 'react-router-dom'

import { Grid, Stack } from '@mui/material'
import { Box } from '@mui/system'
import { useGetAnimal } from '../../APIs/Hooks/AnimalHooks'
import PageSection from '../../Constants&Theme/PageSection'
import AnimalHistory from './AnimalHistory'
import { formatValueDateTime } from '../../Functions/FormatValues'
import { stackGap } from '../../Constants&Theme/Spacing'
import { ReadOnlyTextField } from '../../garvan-react/Components/ReadOnlyTextField'
import { useSampleContext } from '../../Contexts/Modules/SampleModule/SampleModule'
import {
  getCodeSetLabelFromList,
  getCodeSetLabelLookup,
} from '../../Functions/CodeSetFns'
import GridCard from '../../Components/GridCard'
import { useUserContext } from '../../Contexts/UserConfig'

function AnimalDetails({ modalUAI }: { modalUAI?: string }) {
  const { UAI } = useParams()
  const { data: animal, isLoading } = useGetAnimal(modalUAI ?? UAI)
  const { statusCodesQuery } = useSampleContext()
  const { loginConfig } = useUserContext()
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection
        title={'Animal Details'}
        loading={isLoading}
      >
        <Stack
          width={1}
          gap={stackGap.col}
        >
          <Stack
            direction={'row'}
            width={1}
            gap={stackGap.row}
          >
            <ReadOnlyTextField
              label="Animal ID"
              value={animal?.AnimalID || ''}
              fullWidth
              sx={{ flex: 1.2 }}
            />
            <ReadOnlyTextField
              label="Status"
              fullWidth
              value={getCodeSetLabelFromList(
                statusCodesQuery?.data,
                animal?.Status,
              )}
              sx={{ flex: 2 }}
            />
            <ReadOnlyTextField
              fullWidth
              label="Line"
              value={animal?.ShortLineName || ''}
              sx={{ flex: 5 }}
            />
          </Stack>
          <Stack
            direction={'row'}
            width={1}
            gap={stackGap.row}
          >
            <ReadOnlyTextField
              label="Ethics"
              value={animal?.EthicsNumber || ''}
              fullWidth
            />
            <ReadOnlyTextField
              label="Breeding Pair"
              value={animal?.BPID || ''}
              fullWidth
            />
            <ReadOnlyTextField
              label="Identified"
              value={formatValueDateTime(animal?.DateIdentified)}
              fullWidth
            />
          </Stack>
          <Stack
            direction={'row'}
            width={1}
            gap={stackGap.row}
          >
            <ReadOnlyTextField
              label="DOB"
              value={formatValueDateTime(animal?.DOB)}
              fullWidth
            />
            <ReadOnlyTextField
              label="Alternate ID"
              value={animal?.AlternateID ?? ''}
              fullWidth
            />
            <ReadOnlyTextField
              label="Import ID"
              value={animal?.ImportID ?? ''}
              fullWidth
            />
          </Stack>
        </Stack>
      </PageSection>
      <PageSection
        title={'Samples'}
        loading={isLoading}
      >
        <Grid
          container
          spacing={2}
        >
          {(animal?.Samples ?? []).map((item) => {
            return (
              <GridCard
                aria-label={'Sample Card'}
                key={item.SampleID}
                onClick={
                  modalUAI ? undefined : (
                    () => navigate('/stuart/sample/info/' + item.SampleID)
                  )
                }
                id={item.SampleID}
                size={4}
                title={item.SampleID}
                subtitle={
                  getCodeSetLabelLookup(
                    loginConfig,
                    ['SampleRunTypeID'],
                    item.SampleType,
                  ) || ''
                }
                attributes={[
                  getCodeSetLabelLookup(
                    loginConfig,
                    ['SampleStatusID'],
                    item.Status,
                  ) || '',
                ]}
              />
            )
          })}
        </Grid>
      </PageSection>
      <PageSection title={'History'}>
        <AnimalHistory
          history={animal?.History ?? []}
          loading={isLoading}
        />
      </PageSection>
    </Box>
  )
}

export default AnimalDetails
